import { render, staticRenderFns } from "./SearchDetail.vue?vue&type=template&id=6e8c356e&scoped=true"
import script from "./SearchDetail.vue?vue&type=script&lang=js"
export * from "./SearchDetail.vue?vue&type=script&lang=js"
import style0 from "./SearchDetail.vue?vue&type=style&index=0&id=6e8c356e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8c356e",
  null
  
)

export default component.exports